import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { FcGoogle } from "react-icons/fc";
import { motion } from "framer-motion";

const SignUp = () => {
  const { t } = useTranslation();
  const { signUp, signInWithGoogle } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { lang } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signUp(email, password, name);
      navigate(`/${lang || "en"}/profile`);
    } catch (err) {
      setError(t("signup.error"));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
      navigate(`/${lang || "en"}/profile`);
    } catch (err) {
      setError(t("signup.google_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="container mx-auto p-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <form
        onSubmit={handleSubmit}
        className="max-w-md mx-auto p-6 glass rounded-lg animate-slide-in text-center"
      >
        <h2 className="text-2xl font-bold primary-text mb-4">{t("signup.title")}</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <div className="custom-input">
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder=" "
            required
            dir="auto"
          />
          <label htmlFor="name">{t("signup.name")}</label>
        </div>
        <div className="custom-input">
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder=" "
            required
            dir="auto"
          />
          <label htmlFor="email">{t("signup.email")}</label>
        </div>
        <div className="custom-input">
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder=" "
            required
            dir="auto"
          />
          <label htmlFor="password">{t("signup.password")}</label>
        </div>
        <button
          type="submit"
          className="w-full p-2 bg-transparent border border-blue-500 primary-text hover:bg-blue-500 hover:text-white rounded transition-all flex items-center justify-center"
          disabled={loading}
        >
          {loading ? <div className="loading-spinner mr-2"></div> : t("signup.button")}
        </button>
        <button
          type="button"
          onClick={handleGoogleSignUp}
          className="w-full p-2 mt-4 bg-transparent border border-blue-500 primary-text hover:bg-blue-500 hover:text-white rounded flex items-center justify-center transition-all"
          disabled={loading}
        >
          {loading ? <div className="loading-spinner mr-2"></div> : <FcGoogle className="mr-2" />}
          {t("signup.google")}
        </button>
      </form>
    </motion.div>
  );
};

export default SignUp;